import { ScheduleBaseModel } from '../../../models';
import { dayOptions, everyDayIndex } from '../../../constants';

export function mapEditableSchedule(
  values: ScheduleBaseModel[],
  editableId?: string,
): ScheduleBaseModel[] {
  if (!editableId) {
    return values.reduce((acum, item) => {
      if (item.day === everyDayIndex) {
        const { timeFrom, timeTo } = item;

        return [
          ...acum,
          ...dayOptions.map((_, index) => ({
            day: index,
            timeFrom,
            timeTo,
          })),
        ];
      }

      return [...acum, item];
    }, []);
  }

  const value = values[0];

  if (value.ids) {
    const { timeTo, timeFrom } = value;

    return value.ids.map(({ id, day }) => ({
      timeTo,
      timeFrom,
      id,
      day,
    }));
  }

  const { timeTo, timeFrom, day } = value;

  return [
    {
      timeTo,
      timeFrom,
      day,
      id: editableId,
    },
  ];
}
